import { observer } from 'mobx-react-lite'

import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'

import {
  useGlobalCopyStore,
  useRecurringTransactionsStore,
  useWidgetContainerProvider,
} from '../../common'
import { type Recurrence } from '../../core'
import { DATE_FORMATS_INTL, formatDate } from '../../core/constants'

import { RecurrenceCalendar } from './recurrencecalendar/RecurrenceCalendar'
import { RecurrenceList } from './RecurrenceList'
import { buildDynamicCopy } from '../../core/utils/Localization'

export const MiniWidgetContent = observer(() => {
  const { recurring: copy } = useGlobalCopyStore()
  const { availableWidth } = useWidgetContainerProvider()
  const {
    selectedDay,
    selectedDayRecurrences,
    setSelectedDay,
    setSelectedRecurrence,
    setSelectedRepeatingTransactionGuid,
    upcomingRecurrences,
  } = useRecurringTransactionsStore()

  const onRecurrenceClick = (recurrence: Recurrence) => {
    setSelectedRepeatingTransactionGuid(recurrence.repeatingTransactionGuid)
    setSelectedRecurrence(recurrence)
  }

  const isSmall = availableWidth < 750

  return (
    <Stack flexDirection={isSmall ? 'column' : 'row'} width="100%">
      <RecurrenceCalendar />

      {!isSmall && <Divider flexItem={true} orientation="vertical" sx={{ my: 16, ml: 16 }} />}

      <RecurrenceList
        isMini={true}
        onRecurrenceClick={onRecurrenceClick}
        onResetClick={selectedDay ? () => setSelectedDay(selectedDay) : undefined}
        recurrences={selectedDayRecurrences || upcomingRecurrences.slice(0, 5)}
        sx={{ width: isSmall ? '100%' : 'calc(100% - 336px)', mt: 12 }}
        title={
          selectedDay
            ? (buildDynamicCopy(
                copy.day_transactions,
                formatDate(selectedDay, DATE_FORMATS_INTL.MONTH_DAY),
              ) as string)
            : copy.upcoming_activity
        }
      />
    </Stack>
  )
})
